// Formats logging to the browser console and stops logging to
//   node production builds.
const ConsoleHelper = (data, level = 'INFO') => {
    if (process.env.NODE_ENV === 'production') return;
    // eslint-disable-next-line no-console
    console.log(`${level}: ${data}`);
};

export default ConsoleHelper;
